import type { ReactNode } from 'react'

/**
 * A payment moment: it takes the whole order side on a solid surface, so the
 * one thing the customer has to do is the only thing there. The order stays
 * mounted underneath and returns with the next cart.
 */
export default function Moment({ children }: { children: ReactNode }) {
  return (
    <div className="absolute inset-0 z-10 flex motion-safe:animate-momentIn flex-col items-center justify-center bg-canvas px-cfd-gutter py-cfd-4">
      {children}
    </div>
  )
}

/** The round mark that opens a moment. `tone` picks the colours. */
export function MomentIcon({ tone, children }: { tone: 'trust' | 'danger'; children: ReactNode }) {
  const colours = tone === 'trust' ? 'bg-trust-500 text-white' : 'bg-danger/10 text-danger'
  return (
    <div className={`mb-cfd-3 flex h-[clamp(44px,8.5vh,88px)] w-[clamp(44px,8.5vh,88px)] items-center justify-center rounded-full text-cfd-title ${colours}`}>
      {children}
    </div>
  )
}

const HEADLINE_TONE = { ink: 'text-primary', danger: 'text-danger' }

export function MomentHeadline({ tone = 'ink', className = '', children }: { tone?: 'ink' | 'danger'; className?: string; children: ReactNode }) {
  return (
    <div className={`text-center font-volte-semibold text-cfd-title ${HEADLINE_TONE[tone]} ${className}`}>
      {children}
    </div>
  )
}

export function MomentText({ className = '', children }: { className?: string; children: ReactNode }) {
  return <div className={`mt-cfd-1 max-w-[34ch] text-center text-cfd-detail text-text-mid ${className}`}>{children}</div>
}
